// import { useEffect, useState } from "react";
// (removed duplicate import)
// import { toast, ToastContainer } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { useDarkMode } from '../../App';

// // دالة إنشاء Session ID
// const generateSessionId = () => {
//     return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
// };

// const getSessionId = () => {
//     let sessionId = sessionStorage.getItem('sessionId');
//     if (!sessionId) {
//         sessionId = generateSessionId();
//         sessionStorage.setItem('sessionId', sessionId);
//     }
//     return sessionId;
// };

// // دوال API
// const fetchEmployees = async () => {
//     const sessionId = getSessionId();
//     const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/employees`, {
//         method: 'GET',
//         headers: {
//             'X-Session-Id': sessionId
//         }
//     });
//     return response.json();
// };

// const fetchShippingCompanies = async () => {
//     const sessionId = getSessionId();
//     const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/shippingCompany`, {
//         method: 'GET',
//         headers: {
//             'X-Session-Id': sessionId
//         }
//     });
//     return response.json();
// };

// const fetchPaymentOptions = async () => {
//     const sessionId = getSessionId();
//     const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/payment-options`, {
//         method: 'GET',
//         headers: {
//             'X-Session-Id': sessionId
//         }
//     });
//     return response.json();
// };

// // دالة جلب ملخص الطلب
// const fetchOrderSummary = async (language) => {
//     try {
//         const sessionId = getSessionId();
//         const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/order/summary`, {
//             method: 'GET',
//             headers: {
//                 'X-Session-Id': sessionId,
//                 'Accept-Language': language || 'en'
//             }
//         });

//         if (!response.ok) {
//             throw new Error('Failed to fetch order summary');
//         }

//         const result = await response.json();
//         return result;
//     } catch (error) {
//         console.error('Error fetching order summary:', error);
//         throw error;
//     }
// };

// // دالة إزالة الكوبون
// const removeCoupon = async (couponCode, language) => {
//     try {
//         const sessionId = getSessionId();
//         const formData = new FormData();
//         formData.append('coupon_code', couponCode);

//         const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/cart/remove-coupon`, {
//             method: 'POST',
//             headers: {
//                 'X-Session-Id': sessionId,
//                 'Accept-Language': language || 'en'
//             },
//             body: formData
//         });

//         if (!response.ok) {
//             throw new Error('Failed to remove coupon');
//         }

//         const result = await response.json();
//         return result;
//     } catch (error) {
//         console.error('Error removing coupon:', error);
//         throw error;
//     }
// };

// const submitUserContact = async (formData) => {
//     const sessionId = getSessionId();
//     const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/user-contact`, {
//         method: 'POST',
//         headers: {
//             'X-Session-Id': sessionId
//         },
//         body: formData
//     });
//     return response.json();
// };

// const processCheckout = async (paymentOptionId) => {
//     const sessionId = getSessionId();
//     const formData = new FormData();
//     formData.append('payment_option_id', paymentOptionId);
    
//     const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/checkout/process`, {
//         method: 'POST',
//         headers: {
//             'X-Session-Id': sessionId
//         },
//         body: formData
//     });
//     return response.json();
// };

// function Checkout() {
// (removed duplicate useTranslation)
//     const navigate = useNavigate();
//     const { isDarkMode } = useDarkMode();

//     // State for form fields
//     const [fullname, setFullname] = useState("");
//     const [phone, setPhone] = useState("");
//     const [country, setCountry] = useState("");
//     const [governorate, setGovernorate] = useState("");
//     const [address, setAddress] = useState("");
//     const [station, setStation] = useState("");
//     const [details, setDetails] = useState("");
//     const [employeeId, setEmployeeId] = useState("");
//     const [shippingCompanyId, setShippingCompanyId] = useState("");
//     const [paymentOptionId, setPaymentOptionId] = useState(null);
//     const [formError, setFormError] = useState("");
//     const [formSuccess, setFormSuccess] = useState("");

//     // API Data
//     const [employees, setEmployees] = useState([]);
//     const [shippingCompanies, setShippingCompanies] = useState([]);
//     const [paymentOptions, setPaymentOptions] = useState([]);
//     const [isLoadingEmployees, setIsLoadingEmployees] = useState(false);
//     const [isLoadingShipping, setIsLoadingShipping] = useState(false);
//     const [isLoadingPayment, setIsLoadingPayment] = useState(false);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [isProcessingCheckout, setIsProcessingCheckout] = useState(false);

//     // Cart data from API
//     const [cartItems, setCartItems] = useState([]);
//     const [cartTotals, setCartTotals] = useState({ subtotal: 0, discount: 0, shipping: 0, total: 0 });
//     const [isLoadingCart, setIsLoadingCart] = useState(true);

//     // Order summary state
//     const [showOrderSummary, setShowOrderSummary] = useState(false);
//     const [orderData, setOrderData] = useState(null);
//     const [contactSubmitted, setContactSubmitted] = useState(false);
//     const [orderSummary, setOrderSummary] = useState(null);
//     const [isLoadingSummary, setIsLoadingSummary] = useState(false);
//     const [isRemovingCoupon, setIsRemovingCoupon] = useState(false);
    
//     // Phone validation state
//     const [phoneError, setPhoneError] = useState("");

//     // دالة التحقق من رقم الهاتف
//     const validatePhone = (phoneNumber) => {
//         if (!phoneNumber) {
//             setPhoneError("");
//             return true;
//         }
        
//         const phoneRegex = /^[0-9+\-\s()]+$/;
//         if (!phoneRegex.test(phoneNumber)) {
//             setPhoneError(t("checkout.phoneValidation"));
//             return false;
//         }
        
//         const cleanPhone = phoneNumber.replace(/[^0-9]/g, '');
//         if (cleanPhone.length < 7 || cleanPhone.length > 15) {
//             setPhoneError(t("checkout.phoneLength"));
//             return false;
//         }
        
//         setPhoneError("");
//         return true;
//     };

//     // دالة تحديث رقم الهاتف مع التحقق
//     const handlePhoneChange = (e) => {
//         const value = e.target.value;
//         // السماح فقط بالأرقام والرموز المسموحة
//         const allowedChars = /^[0-9+\-\s()]*$/;
//         if (allowedChars.test(value)) {
//             setPhone(value);
//             validatePhone(value);
//         }
//     };

//     // دالة منع إدخال أحرف غير مسموحة
//     const handlePhoneKeyPress = (e) => {
//         const allowedChars = /[0-9+\-\s()]/;
//         if (!allowedChars.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
//             e.preventDefault();
//         }
//     };

//     // دالة جلب ملخص الطلب
//     const loadOrderSummary = async () => {
//         try {
//             setIsLoadingSummary(true);
//             const summaryData = await fetchOrderSummary(i18n.language);
//             if (summaryData.status && summaryData.data) {
//                 setOrderSummary(summaryData.data);
//             }
//         } catch (error) {
//             console.error('Error loading order summary:', error);
//         } finally {
//             setIsLoadingSummary(false);
//         }
//     };

//     // دالة حذف الكوبون
//     const handleRemoveCoupon = async () => {
//         if (!orderSummary?.coupon_code) {
//             return;
//         }

//         try {
//             setIsRemovingCoupon(true);
//             const result = await removeCoupon(orderSummary.coupon_code, i18n.language);
            
//             if (result.status) {
//                 toast.success(result.message || t("cart.couponApplied"));
//                 // إعادة تحميل ملخص الطلب بعد حذف الكوبون
//                 await loadOrderSummary();
//             }
//         } catch (error) {
//             console.error('Error removing coupon:', error);
//             toast(t("cart.errorRemovingCoupon"));
//         } finally {
//             setIsRemovingCoupon(false);
//         }
//     };

//     // تحميل البيانات من API
//     useEffect(() => {
//         const loadData = async () => {
//             try {
//                 // تحميل السلة من API
//                 const sessionId = getSessionId();
//                 const cartResponse = await fetch(`${process.env.REACT_APP_BASE_URL}/api/cart`, {
//                     method: 'GET',
//                     headers: {
//                         'X-Session-Id': sessionId
//                     }
//                 });
//                 const cartData = await cartResponse.json();
                
//                 if (cartData.status && cartData.data) {
//                     setCartItems(cartData.data.items || []);
//                     setCartTotals(cartData.data.totals || { subtotal: 0, discount: 0, shipping: 0, total: 0 });
//                 }
                
//                 // تحميل الموظفين
//                 setIsLoadingEmployees(true);
//                 const employeesData = await fetchEmployees();
//                 if (employeesData.status && employeesData.data) {
//                     setEmployees(employeesData.data);
//                 }
//                 setIsLoadingEmployees(false);
                
//                 // تحميل شركات الشحن
//                 setIsLoadingShipping(true);
//                 const shippingData = await fetchShippingCompanies();
//                 if (shippingData.status && shippingData.data) {
//                     setShippingCompanies(shippingData.data);
//                 }
//                 setIsLoadingShipping(false);
                
//                 // تحميل خيارات الدفع
//                 setIsLoadingPayment(true);
//                 const paymentData = await fetchPaymentOptions();
//                 if (paymentData.status && paymentData.data) {
//                     setPaymentOptions(paymentData.data);
//                 }
//                 setIsLoadingPayment(false);
                
//                 // تحميل ملخص الطلب
//                 await loadOrderSummary();
                
//             } catch (error) {
//                 console.error('Error loading data:', error);
//                 toast(t("common.error"));
//                 setIsLoadingEmployees(false);
//                 setIsLoadingShipping(false);
//                 setIsLoadingPayment(false);
//             } finally {
//                 setIsLoadingCart(false);
//             }
//         };
        
//         loadData();
//     }, []);

//     // دالة إرسال بيانات الاتصال
//     const handleSubmitContact = async (e) => {
//         e.preventDefault();
//         setFormError("");
//         setFormSuccess("");
        
//         // تحقق من ملء الحقول المطلوبة
//         if (!fullname || !phone || !country || !governorate || !address || !station || !employeeId || !shippingCompanyId) {
//             setFormError(t("checkout.requiredFields"));
//             toast(t("checkout.requiredFields"), { autoClose: 1500 });
//             return;
//         }

//         // تحقق من صحة رقم الهاتف
//         if (!validatePhone(phone)) {
//             setFormError(phoneError);
//             toast(phoneError, { autoClose: 1500 });
//             return;
//         }

//         // تحقق من وجود منتجات في السلة
//         if (cartItems.length === 0) {
//             setFormError(t("checkout.emptyCartMessage"));
//             toast(t("checkout.emptyCartMessage"), { autoClose: 1500 });
//             return;
//         }
        
//         try {
//             setIsSubmitting(true);
            
//             // إعداد FormData
//             const formData = new FormData();
//             formData.append('employee_id', employeeId);
//             formData.append('phone', phone);
//             formData.append('shipping_company_id', shippingCompanyId);
//             formData.append('details', details);
//             formData.append('station', station);
//             formData.append('governorate', governorate);
//             formData.append('address', address);
//             formData.append('fullname', fullname);
//             formData.append('country', country);

//             // إرسال البيانات
//             const result = await submitUserContact(formData);
//             // //console.log({result});
            
//             if (result.status) {
//                 toast.success(result.message || t("checkout.contactSuccess"));
//                 setFormSuccess(t("checkout.contactSuccess"));
                
//                 // حفظ بيانات الطلب
//                 setOrderData({
//             contactData: {
//                         fullname,
//                         phone,
//                         country,
//                 governorate,
//                         address,
//                         station,
//                 details,
//                         employee: employees.find(emp => emp.id == employeeId),
//                         shippingCompany: shippingCompanies.find(comp => comp.id == shippingCompanyId)
//                     },
//                     cartItems,
//                     cartTotals
//                 });
                
//                 // تمييز أن بيانات الاتصال تم إرسالها
//                 setContactSubmitted(true);
                
//             } else {
//                 setFormError(result.message || t("checkout.contactError"));
//                 toast(result.message || t("checkout.contactError"));
//             }
            
//         } catch (error) {
//             console.error('Error submitting contact:', error);
//             setFormError(t("checkout.contactError"));
//             toast(t("checkout.contactError"));
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     // دالة إظهار عملية الدفع
//     const handleShowCheckout = async () => {
//         // تحميل ملخص الطلب قبل إظهار عملية الدفع
//         await loadOrderSummary();
//         setShowOrderSummary(true);
//     };

//     // دالة إتمام عملية الشراء
//     const handleProcessCheckout = async () => {
//         if (!paymentOptionId) {
//             toast(t("checkout.selectPaymentFirst"));
//             return;
//         }

//         try {
//             setIsProcessingCheckout(true);
            
//             const result = await processCheckout(paymentOptionId, {}, i18n.language);
            
//             // //console.log({pay:result});
//             if (result.status) {
//                 // عرض رسالة النجاح بالعربية
//                 const successMessage = result.message === 'order.created' 
//                     ? t("checkout.orderCreated") + (result.data?.order_id || '')
//                     : (result.message || t("checkout.completePurchase"));
                
//                 toast.success(successMessage, {
//                     autoClose: 5000,
//                     position: "top-center"
//                 });

//         setTimeout(() => {
//                     navigate('/');
//         }, 2000);
                
//             } else {
//                 toast(result.message || t("checkout.checkoutError"));
//             }
            
//         } catch (error) {
//             console.error('Error processing checkout:', error);
//             toast(t("checkout.checkoutError"));
//         } finally {
//             setIsProcessingCheckout(false);
//         }
//     };

//     // حساب المجاميع من API
//     const subtotal = cartTotals.subtotal || 0;
//     const discount = cartTotals.discount || 0;
//     const shippingCost = cartTotals.shipping || 0;
//     const finalTotal = cartTotals.total || 0;


//     if (isLoadingCart) {
//         return (
//             <div className="container text-center my-5">
//                 <div className="spinner-border text-primary" role="status">
//                     <span className="visually-hidden">{t("checkout.loadingCart")}</span>
//                 </div>
//                 <p className="mt-3">{t("checkout.loadingCart")}</p>
//             </div>
//         );
//     }

//     if (cartItems.length === 0) {
//         return (
//             <div className="container text-center my-5">
//                 <i className="fas fa-shopping-cart fa-3x mb-3 text-muted"></i>
//                 <h4 className="text-muted">{t("checkout.emptyCartMessage")}</h4>
//                 <p className="text-muted">{t("checkout.emptyCartDescription")}</p>
//                 <button 
//                     className="btn btn-primary"
//                     onClick={() => navigate('/')}
//                 >
//                     {t("checkout.backToShopping")}
//                 </button>
//             </div>
//         );
//     }

//     return (
//         <>
//             <ToastContainer
//                 position="top-center"
//                 autoClose={5000}
//                 hideProgressBar={false}
//                 newestOnTop={false}
//                 closeOnClick
//                 rtl={i18n.language === 'ar'}
//                 pauseOnFocusLoss
//                 draggable
//                 pauseOnHover
//                 theme={isDarkMode ? 'dark' : 'light'}
//                 style={{
//                     fontSize: '16px',
//                     fontWeight: '500'
//                 }}
//             />
//             <div className={`breadcrumb-box text-center py-5 mb-4 rounded ${isDarkMode ? 'dark-mode' : ''}`} style={{ background: isDarkMode ? 'var(--color-card)' : "#000c3d0D" }} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
//                 <h4 className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("checkout.title", "إتمام الطلب")}</h4>
//                 <p className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("checkout.breadcrumb", "الرئيسية / السلة / إتمام الطلب")}</p>
//             </div>

//             <section className={`checkout container mb-5 ${isDarkMode ? 'dark-mode' : ''}`} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
//                 <div className="row">
//                     {!showOrderSummary ? (
//                         <form className="col-md-12 row" onSubmit={handleSubmitContact}>
//                             <div className={`col-md-7 border rounded p-4 ${isDarkMode ? 'dark-mode' : ''}`} style={{
//                                 backgroundColor: isDarkMode ? 'var(--color-card)' : undefined,
//                                 borderColor: isDarkMode ? 'var(--color-border)' : undefined
//                             }}>
//                                 <h6 className="fw-bold mb-3" style={{ color: isDarkMode ? 'var(--color-primary)' : undefined }}>{t("checkout.contactInfo", "معلومات جهة الاتصال")}</h6>
                                
//                                 {/* الاسم الكامل */}
//                             <div className="mb-3">
//                                     <label className="form-label fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("checkout.fullname", "الاسم الكامل")} *</label>
//                                 <input 
//                                     type="text" 
//                                     className="form-control" 
//                                         placeholder={t("checkout.fullnamePlaceholder", "أدخل الاسم الكامل")} 
//                                         value={fullname} 
//                                         onChange={e => setFullname(e.target.value)} 
//                                     required
//                                         style={{
//                                             backgroundColor: isDarkMode ? 'var(--color-card)' : undefined,
//                                             borderColor: isDarkMode ? 'var(--color-border)' : undefined,
//                                             color: isDarkMode ? 'var(--color-text)' : undefined
//                                         }}
//                                 />
//                             </div>
                            
//                             {/* رقم الهاتف */}
//                             <div className="mb-3">
//                                     <label className="form-label fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("checkout.phone", "رقم الهاتف")} *</label>
//                                 <input 
//                                     type="tel" 
//                                         className={`form-control ${i18n.language === 'ar' ? 'text-end ' : 'text-start '} ${phoneError ? 'is-invalid' : ''}`}
//                                     placeholder={t("checkout.phonePlaceholder", "أدخل رقم الهاتف")}
//                                         value={phone} 
//                                         onChange={handlePhoneChange}
//                                         onKeyPress={handlePhoneKeyPress}
//                                     required
//                                         style={{
//                                             backgroundColor: isDarkMode ? 'var(--color-card)' : undefined,
//                                             borderColor: isDarkMode ? 'var(--color-border)' : undefined,
//                                             color: isDarkMode ? 'var(--color-text)' : undefined
//                                         }}
//                                     />
//                                     {phoneError && (
//                                         <div className="invalid-feedback">
//                                             {phoneError}
//                                         </div>
//                                     )}
//                                     <div className="form-text" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>
//                                         {t("checkout.phoneExample")}
//                                     </div>
//                             </div>
                            
//                                 {/* البلد */}
//                             <div className="mb-3">
//                                     <label className="form-label fw-bold">{t("checkout.country", "البلد")} *</label>
//                                     <input 
//                                         type="text" 
//                                     className="form-control" 
//                                         placeholder={t("checkout.countryPlaceholder", "أدخل اسم البلد")} 
//                                         value={country} 
//                                         onChange={e => setCountry(e.target.value)} 
//                                         required
//                                     />
//                             </div>
                            
//                             {/* المحافظة */}
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">{t("checkout.governorate", "المحافظة")} *</label>
//                                 <input 
//                                     type="text" 
//                                     className="form-control" 
//                                     placeholder={t("checkout.governoratePlaceholder", "أدخل اسم المحافظة")} 
//                                     value={governorate} 
//                                     onChange={e => setGovernorate(e.target.value)} 
//                                     required
//                                 />
//                             </div>
                            
//                                 {/* العنوان */}
//                             <div className="mb-3">
//                                     <label className="form-label fw-bold">{t("checkout.address", "العنوان")} *</label>
//                                 <input 
//                                     type="text" 
//                                     className="form-control" 
//                                         placeholder={t("checkout.addressPlaceholder", "أدخل العنوان")} 
//                                         value={address} 
//                                         onChange={e => setAddress(e.target.value)} 
//                                     required
//                                 />
//                             </div>
                            
//                                 {/* المحطة */}
//                             <div className="mb-3">
//                                     <label className="form-label fw-bold">{t("checkout.station", "المحطة")} *</label>
//                                     <input 
//                                         type="text" 
//                                     className="form-control" 
//                                         placeholder={t("checkout.stationPlaceholder", "أدخل اسم المحطة")} 
//                                         value={station} 
//                                         onChange={e => setStation(e.target.value)} 
//                                         required
//                                     />
//                                 </div>
                                
//                                 {/* الموظف */}
//                                 <div className="mb-3">
//                                     <label className="form-label fw-bold">{t("checkout.employee", "الموظف")} *</label>
//                                     <select 
//                                         className="form-select" 
//                                         value={employeeId} 
//                                         onChange={e => setEmployeeId(e.target.value)}
//                                         required
//                                         disabled={isLoadingEmployees}
//                                     >
//                                         <option value="">{isLoadingEmployees ? t("checkout.loadingEmployees") : t("checkout.selectEmployee")}</option>
//                                         {employees.map(employee => (
//                                             <option key={employee.id} value={employee.id}>
//                                                 {employee.name}
//                                             </option>
//                                         ))}
//                                     </select>
//                             </div>
                            
//                             {/* شركة الشحن */}
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">{t("checkout.shippingCompany", "شركة الشحن")} *</label>
//                                 <select 
//                                     className="form-select" 
//                                         value={shippingCompanyId} 
//                                         onChange={e => setShippingCompanyId(e.target.value)}
//                                     required
//                                         disabled={isLoadingShipping}
//                                     >
//                                         <option value="">{isLoadingShipping ? t("checkout.loadingShipping") : t("checkout.selectShippingCompany")}</option>
//                                         {shippingCompanies.map(company => (
//                                             <option key={company.id} value={company.id}>
//                                                 {company.name}
//                                             </option>
//                                         ))}
//                                 </select>
//                             </div>
                                
//                                 {/* تفاصيل إضافية */}
//                                 <div className="mb-3">
//                                     <label className="form-label fw-bold">{t("checkout.details", "تفاصيل إضافية")}</label>
//                                     <textarea 
//                                         className="form-control" 
//                                         rows="3" 
//                                         placeholder={t("checkout.detailsPlaceholder", "تفاصيل إضافية للطلب")} 
//                                         value={details} 
//                                         onChange={e => setDetails(e.target.value)}
//                                     ></textarea>
//                                 </div>
//                         </div>
                        
//                         <div className="col-md-5">
//                             <div className="border rounded p-3 mb-3">
//                                 <h6 className="fw-bold mb-3">{t("checkout.orderSummary", "ملخص الطلب")}</h6>
                                
//                                 <div className={`order-summary rounded p-4 shadow-sm ${isDarkMode ? 'dark-mode' : 'bg-light'}`} style={{
//                                     backgroundColor: isDarkMode ? '#0a0e27' : undefined,
//                                     border: isDarkMode ? '1px solid var(--color-border)' : undefined
//                                 }}>
                                    
//                                     {/* عرض ملخص الطلب من API إذا كان متوفراً */}
//                                     {orderSummary ? (
//                                         <>
//                                             {/* المنتجات */}
//                                             {orderSummary.products && orderSummary.products.length > 0 && (
//                                                 <div className="mb-3">
//                                                     <h6 className="fw-bold mb-2" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("cart.products")}:</h6>
//                                                     {orderSummary.products.map((product, index) => (
//                                                         <div key={index} className="d-flex justify-content-between align-items-center mb-2 p-2" style={{
//                                                             backgroundColor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
//                                                             borderRadius: '8px'
//                                                         }}>
//                                                             <div className="d-flex align-items-center">
//                                                                 <img 
//                                                                     src={product.image} 
//                                                                     alt={product.name}
//                                                                     style={{ width: '40px', height: '40px', borderRadius: '8px', marginRight: '10px' }}
//                                                                 />
//                                                                 <div>
//                                                                     <div className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>
//                                                                         {product.name}
//                                                                     </div>
//                                                                     {product.variant_name && (
//                                                                         <small className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>
//                                                                             {t("cart.variant")} {product.variant_name}
//                                                                         </small>
//                                                                     )}
//                                                                 </div>
//                                                             </div>
//                                                             <div className="text-end">
//                                                                 <div className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>
//                                                                     {product.quantity} × {product.unit_price} {t("cart.currency")}
//                                                                 </div>
//                                                                 <div className="text-warning fw-bold">
//                                                                     = {product.total} {t("cart.currency")}
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             )}

//                                             {/* كود الكوبون */}
//                                             {orderSummary.coupon_code && (
//                                                 <div className="d-flex justify-content-between align-items-center mb-2 p-2" style={{
//                                                     backgroundColor: isDarkMode ? 'rgba(40, 167, 69, 0.1)' : 'rgba(40, 167, 69, 0.1)',
//                                                     borderRadius: '8px',
//                                                     border: '1px solid rgba(40, 167, 69, 0.3)'
//                                                 }}>
//                                                     <span className="text-success fw-bold">{t("cart.couponCode")}: {orderSummary.coupon_code}</span>
//                                                     <button
//                                                         type="button"
//                                                         className="btn btn-sm btn-outline-danger"
//                                                         onClick={handleRemoveCoupon}
//                                                         disabled={isRemovingCoupon}
//                                                         style={{
//                                                             padding: '4px 8px',
//                                                             fontSize: '12px',
//                                                             borderRadius: '4px'
//                                                         }}
//                                                     >
//                                                         {isRemovingCoupon ? (
//                                                             <>
//                                                                 <span className="spinner-border spinner-border-sm mx-1" role="status" aria-hidden="true"></span>
//                                                                 {t("cart.removing")}
//                                                             </>
//                                                         ) : (
//                                                             <>
//                                                                 <i className="fas fa-times mx-1"></i>
//                                                                 {t("cart.removeCoupon")}
//                                                             </>
//                                                         )}
//                                                     </button>
//                                                 </div>
//                                             )}

//                                             {/* المجموع الفرعي */}
//                                             <div className="d-flex justify-content-between mb-2">
//                                                 <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("cart.subtotal")}</span>
//                                                 <span className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>
//                                                     {orderSummary.subtotal} {t("cart.currency")}
//                                                 </span>
//                                             </div>

//                                             {/* مبلغ الخصم */}
//                                             {orderSummary.discount_amount > 0 && (
//                                                 <div className="d-flex justify-content-between mb-2">
//                                                     <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("cart.discount")}</span>
//                                                     <span className="text-success fw-bold">
//                                                         - {orderSummary.discount_amount} {t("cart.currency")}
//                                                     </span>
//                                                 </div>
//                                             )}

//                                             {/* الإجمالي النهائي */}
//                                             <div className="d-flex justify-content-between pt-2 mt-2 border-top" style={{ borderTop: isDarkMode ? '1px solid var(--color-border)' : undefined }}>
//                                                 <span className="h6 mb-0" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("cart.total")}</span>
//                                                 <span className="h5 mb-0 text-warning fw-bold">
//                                                     {orderSummary.final_total} {t("cart.currency")}
//                                                 </span>
//                                             </div>
//                                         </>
//                                     ) : (
//                                         /* عرض البيانات المحلية إذا لم يكن ملخص الطلب متوفراً */
//                                         <>
//                                             {/* المجموع */}
//                                             <div className="d-flex justify-content-between mb-3">
//                                                 <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("checkout.subtotal", "المجموع")}</span>
//                                                 <span className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{subtotal.toFixed(2)} {t("cart.currency", "SAR")}</span>
//                                             </div>

//                                             {/* الخصم */}
//                                             {discount > 0 && (
//                                                 <div className="d-flex justify-content-between mb-3">
//                                                     <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("checkout.discount", "الخصم")}</span>
//                                                     <span className="fw-bold text-success">-{discount.toFixed(2)} {t("cart.currency", "SAR")}</span>
//                                                 </div>
//                                             )}

//                                             {/* الشحن */}
//                                             {shippingCost > 0 && (
//                                                 <div className="d-flex justify-content-between mb-3">
//                                                     <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("checkout.shipping", "الشحن")}</span>
//                                                     <span className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{shippingCost.toFixed(2)} {t("cart.currency", "SAR")}</span>
//                                                 </div>
//                                             )}

//                                             {/* الإجمالي */}
//                                             <div className="d-flex justify-content-between pt-3 mt-3 border-top" style={{ borderTop: isDarkMode ? '1px solid var(--color-border)' : undefined }}>
//                                                 <span className="h6 mb-0" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("checkout.total", "الإجمالي")}</span>
//                                                 <div className="d-flex flex-column align-items-end">
//                                                     <span className="h5 mb-0 fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : "blue" }}>
//                                                         {finalTotal.toFixed(2)} {t("cart.currency", "SAR")}
//                                                     </span>
//                                                     <small className="text-muted mt-1" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>
//                                                         {t("checkout.includingVAT", "شامل الضريبة")}
//                                                     </small>
//                                                 </div>
//                                             </div>
//                                         </>
//                                     )}

//                                     {/* Loading state لملخص الطلب */}
//                                     {isLoadingSummary && (
//                                         <div className="text-center mt-3">
//                                             <div className="spinner-border spinner-border-sm text-primary" role="status">
//                                                 <span className="visually-hidden">Loading...</span>
//                                             </div>
//                                             <span className="ms-2" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>
//                                                 {t("cart.updatingSummary")}
//                                             </span>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                                 {/* رسائل الخطأ/النجاح */}
//                                 {formError && <div className="alert alert-danger text-center">{formError}</div>}
//                                 {formSuccess && <div className="alert alert-success text-center">{formSuccess}</div>}

//                                 <button 
//                                     type="submit" 
//                                     className="btn w-100 text-white fw-bold py-2" 
//                                     style={{ backgroundColor: "#000c3d" }}
//                                     disabled={isSubmitting}
//                                 >
//                                     {isSubmitting ? (
//                                         <>
//                                             <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
//                                             {t("checkout.submitting")}
//                                         </>
//                                     ) : (
//                                         t("checkout.submitContact")
//                                     )}
//                                 </button>

//                                 {/* زر إظهار عملية الدفع - يظهر فقط بعد إرسال بيانات الاتصال بنجاح */}
//                                 {contactSubmitted && !showOrderSummary && (
//                                     <button 
//                                         type="button"
//                                         className="btn w-100 text-white fw-bold py-2 mt-3" 
//                                         style={{ backgroundColor: "#28a745" }}
//                                         onClick={handleShowCheckout}
//                                     >
//                                         <i className="fas fa-credit-card mx-2"></i>
//                                         {t("checkout.proceedToPayment", "المتابعة للدفع")}
//                                     </button>
//                                 )}
//                             </div>
//                         </form>
//                     ) : (
//                         /* ملخص الطلب بعد الإرسال الناجح */
//                         <div className="col-md-12">
//                             <div className="border rounded p-4 mb-4 shadow-sm">
//                                 <h5 className="fw-bold text-success mb-4">
//                                     <i className="fas fa-check-circle mx-2"></i>
//                                     {t("checkout.contactSubmitted")}
//                                 </h5>
                                
//                                 {/* بيانات الاتصال */}
//                                 <div className="row mb-4">
//                                     <div className="col-md-6">
//                                         <div className="card border-0 bg-light">
//                                             <div className="card-header bg-primary text-white">
//                                                 <h6 className="fw-bold mb-0">
//                                                     <i className="fas fa-user mx-2"></i>
//                                                     {t("checkout.contactData")}
//                                                 </h6>
//                                             </div>
//                                             <div className="card-body">
//                                                 <div className="row g-3">
//                                                     <div className="col-12">
//                                                         <div className="d-flex align-items-center">
//                                                             <i className="fas fa-user text-primary mx-3"></i>
//                                                             <div>
//                                                                 <small className="text-muted">{t("checkout.name")}</small>
//                                                                 <div className="fw-bold">{orderData?.contactData?.fullname}</div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-12">
//                                                         <div className="d-flex align-items-center">
//                                                             <i className="fas fa-phone text-primary mx-3"></i>
//                                                             <div>
//                                                                 <small className="text-muted">{t("checkout.phoneNumber")}</small>
//                                                                 <div className="fw-bold">{orderData?.contactData?.phone}</div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-12"></div>
//                                                         <div className="d-flex align-items-center">
//                                                             <i className="fas fa-globe text-primary mx-3"></i>
//                                                             <div>
//                                                                 <small className="text-muted">{t("checkout.countryName")}</small>
//                                                                 <div className="fw-bold">{orderData?.contactData?.country}</div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-12">
//                                                         <div className="d-flex align-items-center">
//                                                             <i className="fas fa-map-marker-alt text-primary mx-3"></i>
//                                                             <div>
//                                                                 <small className="text-muted">{t("checkout.governorateName")}</small>
//                                                                 <div className="fw-bold">{orderData?.contactData?.governorate}</div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-12">
//                                                         <div className="d-flex align-items-center">
//                                                             <i className="fas fa-home text-primary mx-3"></i>
//                                                             <div>
//                                                                 <small className="text-muted">{t("checkout.addressName")}</small>
//                                                                 <div className="fw-bold">{orderData?.contactData?.address}</div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-12">
//                                                         <div className="d-flex align-items-center">
//                                                             <i className="fas fa-train text-primary mx-3"></i>
//                                                             <div>
//                                                                 <small className="text-muted">{t("checkout.stationName")}</small>
//                                                                 <div className="fw-bold">{orderData?.contactData?.station}</div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-12">
//                                                         <div className="d-flex align-items-center">
//                                                             <i className="fas fa-user-tie text-primary mx-3"></i>
//                                                             <div>
//                                                                 <small className="text-muted">{t("checkout.employeeName")}</small>
//                                                                 <div className="fw-bold">{orderData?.contactData?.employee?.name}</div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-12">
//                                                         <div className="d-flex align-items-center">
//                                                             <i className="fas fa-truck text-primary mx-3"></i>
//                                                             <div>
//                                                                 <small className="text-muted">{t("checkout.shippingCompanyName")}</small>
//                                                                 <div className="fw-bold">{orderData?.contactData?.shippingCompany?.name}</div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     {orderData?.contactData?.details && (
//                                                         <div className="col-12">
//                                                             <div className="d-flex align-items-start">
//                                                                 <i className="fas fa-info-circle text-primary mx-3 mt-1"></i>
//                                                                 <div>
//                                                                     <small className="text-muted">{t("checkout.additionalDetails")}</small>
//                                                                     <div className="fw-bold">{orderData.contactData.details}</div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-6">
//                                         <div className="card border-0 bg-light">
//                                             <div className="card-header bg-success text-white">
//                                                 <h6 className="fw-bold mb-0">
//                                                     <i className="fas fa-shopping-cart mx-2"></i>
//                                                     {t("checkout.orderData")}
//                                                 </h6>
//                                             </div>
//                                             <div className="card-body">
//                                                 {/* عرض ملخص الطلب من API إذا كان متوفراً */}
//                                                 {orderSummary ? (
//                                                     <>
//                                                         {/* المنتجات */}
//                                                         {orderSummary.products && orderSummary.products.length > 0 && (
//                                                             <div className="mb-3">
//                                                                 <h6 className="fw-bold mb-2">{t("cart.products")}:</h6>
//                                                                 {orderSummary.products.map((product, index) => (
//                                                                     <div key={index} className="d-flex justify-content-between align-items-center mb-2 p-2" style={{
//                                                                         backgroundColor: 'rgba(0,0,0,0.05)',
//                                                                         borderRadius: '8px'
//                                                                     }}>
//                                                                         <div className="d-flex align-items-center">
//                                                                             <img 
//                                                                                 src={product.image} 
//                                                                                 alt={product.name}
//                                                                                 style={{ width: '30px', height: '30px', borderRadius: '6px', marginRight: '8px' }}
//                                                                             />
//                                                                             <div>
//                                                                                 <div className="fw-bold small">
//                                                                                     {product.name}
//                                                                                 </div>
//                                                                                 {product.variant_name && (
//                                                                                     <small className="text-muted">
//                                                                                         {t("cart.variant")} {product.variant_name}
//                                                                                     </small>
//                                                                                 )}
//                                                                             </div>
//                                                                         </div>
//                                                                         <div className="text-end">
//                                                                             <div className="fw-bold small">
//                                                                                 {product.quantity} × {product.unit_price} {t("cart.currency")}
//                                                                             </div>
//                                                                             <div className="text-warning fw-bold small">
//                                                                                 = {product.total} {t("cart.currency")}
//                                                                             </div>
//                                                                         </div>
//                                                                     </div>
//                                                                 ))}
//                                                             </div>
//                                                         )}

//                                                         {/* كود الكوبون */}
//                                                         {orderSummary.coupon_code && (
//                                                             <div className="d-flex justify-content-between align-items-center mb-2 p-2" style={{
//                                                                 backgroundColor: 'rgba(40, 167, 69, 0.1)',
//                                                                 borderRadius: '8px',
//                                                                 border: '1px solid rgba(40, 167, 69, 0.3)'
//                                                             }}>
//                                                                 <span className="text-success fw-bold small">{t("cart.couponCode")}: {orderSummary.coupon_code}</span>
//                                                                 <button
//                                                                     type="button"
//                                                                     className="btn btn-sm btn-outline-danger"
//                                                                     onClick={handleRemoveCoupon}
//                                                                     disabled={isRemovingCoupon}
//                                                                     style={{
//                                                                         padding: '2px 6px',
//                                                                         fontSize: '10px',
//                                                                         borderRadius: '4px'
//                                                                     }}
//                                                                 >
//                                                                     {isRemovingCoupon ? (
//                                                                         <>
//                                                                             <span className="spinner-border spinner-border-sm mx-1" role="status" aria-hidden="true"></span>
//                                                                             {t("cart.removing")}
//                                                                         </>
//                                                                     ) : (
//                                                                         <>
//                                                                             <i className="fas fa-times mx-1"></i>
//                                                                             {t("cart.removeCoupon")}
//                                                                         </>
//                                                                     )}
//                                                                 </button>
//                                                             </div>
//                                                         )}

//                                                         {/* المجموع الفرعي */}
//                                                         <div className="d-flex justify-content-between align-items-center mb-2">
//                                                             <span className="text-muted">{t("cart.subtotal")}</span>
//                                                             <span className="fw-bold">
//                                                                 {orderSummary.subtotal} {t("cart.currency")}
//                                                             </span>
//                                                         </div>

//                                                         {/* مبلغ الخصم */}
//                                                         {orderSummary.discount_amount > 0 && (
//                                                             <div className="d-flex justify-content-between align-items-center mb-2">
//                                                                 <span className="text-muted">{t("cart.discount")}</span>
//                                                                 <span className="text-success fw-bold">
//                                                                     - {orderSummary.discount_amount} {t("cart.currency")}
//                                                                 </span>
//                                                             </div>
//                                                         )}

//                                                         {/* الإجمالي النهائي */}
//                                                         <hr />
//                                                         <div className="d-flex justify-content-between align-items-center">
//                                                             <span className="h6 mb-0">{t("cart.total")}</span>
//                                                             <span className="h5 mb-0 fw-bold text-primary">
//                                                                 {orderSummary.final_total} {t("cart.currency")}
//                                                             </span>
//                                                         </div>
//                                                     </>
//                                                 ) : (
//                                                     /* عرض البيانات المحلية إذا لم يكن ملخص الطلب متوفراً */
//                                                     <>
//                                                         <div className="d-flex justify-content-between align-items-center mb-3">
//                                                             <span className="text-muted">المجموع</span>
//                                                             <span className="fw-bold">{orderData?.cartTotals?.subtotal?.toFixed(2)} SAR</span>
//                                                         </div>
//                                                         {orderData?.cartTotals?.discount > 0 && (
//                                                             <div className="d-flex justify-content-between align-items-center mb-3">
//                                                                 <span className="text-muted">الخصم</span>
//                                                                 <span className="fw-bold text-success">-{orderData.cartTotals.discount.toFixed(2)} SAR</span>
//                                                             </div>
//                                                         )}
//                                                         {orderData?.cartTotals?.shipping > 0 && (
//                                                             <div className="d-flex justify-content-between align-items-center mb-3">
//                                                                 <span className="text-muted">الشحن</span>
//                                                                 <span className="fw-bold">{orderData.cartTotals.shipping.toFixed(2)} SAR</span>
//                                                             </div>
//                                                         )}
//                                                         <hr />
//                                                         <div className="d-flex justify-content-between align-items-center">
//                                                             <span className="h6 mb-0">الإجمالي</span>
//                                                             <span className="h5 mb-0 fw-bold text-primary">{orderData?.cartTotals?.total?.toFixed(2)} SAR</span>
//                                                         </div>
//                                                     </>
//                                                 )}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* خيارات الدفع */}
//                                 <div className="card border-0 shadow-sm mb-4">
//                                     <div className="card-header bg-warning text-dark">
//                                         <h6 className="fw-bold mb-0">
//                                             <i className="fas fa-credit-card mx-2"></i>
//                                             {t("checkout.paymentOptions", "خيارات الدفع")}
//                                         </h6>
//                                     </div>
//                                     <div className="card-body">
//                                         {isLoadingPayment ? (
//                                             <div className="text-center py-4">
//                                                 <div className="spinner-border text-primary" role="status">
//                                                     <span className="visually-hidden">{t("checkout.loadingPayment")}</span>
//                                                 </div>
//                                                 <p className="mt-2 text-muted">{t("checkout.loadingPayment")}</p>
//                                             </div>
//                                         ) : (
//                                             <div className="row g-3">
//                                 {paymentOptions.map((option, idx) => (
//                                                     <div className="col-12" key={option.id || idx}>
//                                                         <div 
//                                                             className={`form-check p-4 border rounded hover-shadow transition-all ${
//                                                                 paymentOptionId === option.id 
//                                                                     ? 'border-primary bg-primary-subtle' 
//                                                                     : 'border-light'
//                                                             }`} 
//                                                             style={{ 
//                                                                 cursor: 'pointer',
//                                                                 transition: 'all 0.3s ease'
//                                                             }}
//                                                             onClick={() => setPaymentOptionId(option.id)}
//                                                         >
//                                                             <div className="d-flex align-items-center">
//                                                                 <div className="mx-3">
//                                                                     <div className="position-relative">
//                                         <input 
//                                                                             className="form-check-input position-absolute" 
//                                             type="radio" 
//                                             name="paymentOption" 
//                                             id={`payopt${option.id || idx}`} 
//                                             value={option.id} 
//                                             checked={paymentOptionId === option.id} 
//                                             onChange={() => setPaymentOptionId(option.id)} 
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 margin: 0,
//                                                                                 opacity: 0,
//                                                                                 zIndex: 2
//                                                                             }}
//                                                                         />
//                                                                         <div 
//                                                                             className={`rounded-circle border d-flex align-items-center justify-content-center ${
//                                                                                 paymentOptionId === option.id 
//                                                                                     ? 'border-primary bg-primary' 
//                                                                                     : 'border-secondary'
//                                                                             }`}
//                                                                             style={{
//                                                                                 width: '20px',
//                                                                                 height: '20px',
//                                                                                 position: 'relative',
//                                                                                 zIndex: 1
//                                                                             }}
//                                                                         >
//                                                                             {paymentOptionId === option.id && (
//                                                                                 <i className="fas fa-check text-white" style={{ fontSize: '10px' }}></i>
//                                                                             )}
//                                                                         </div>
//                                                                     </div>
//                                                                 </div>
                                                                
//                                                                 <div className="flex-grow-1">
//                                                                     <div className="d-flex align-items-center mb-2">
//                                                                         <i className="fas fa-credit-card text-primary mx-3" style={{ fontSize: '1.5rem' }}></i>
//                                                                         <div>
//                                                                             <div className="fw-bold h6 mb-0">
//                                             {i18n.language === 'ar' ? option.name_ar : option.name_en}
//                                                                             </div>
//                                                                             <small className="text-muted">{t("checkout.selectPaymentMethod")}</small>
//                                                                         </div>
//                                                                     </div>
//                                                                 </div>
                                                                
//                                                                 {paymentOptionId === option.id && (
//                                                                     <div className="text-primary">
//                                                                         <i className="fas fa-check-circle" style={{ fontSize: '1.2rem' }}></i>
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* زر إتمام الشراء */}
//                                 <div className="d-grid">
//                                     <button 
//                                         className="btn btn-success btn-lg fw-bold py-3 shadow-sm" 
//                                         onClick={handleProcessCheckout}
//                                         disabled={!paymentOptionId || isProcessingCheckout}
//                                         style={{ 
//                                             backgroundColor: isProcessingCheckout ? "#6c757d" : "#28a745",
//                                             border: "none",
//                                             borderRadius: "10px",
//                                             fontSize: "1.1rem"
//                                         }}
//                                     >
//                                         {isProcessingCheckout ? (
//                                             <>
//                                                 <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
//                                                 {t("checkout.processingCheckout")}
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <i className="fas fa-check-circle mx-2"></i>
//                                                 {t("checkout.completePurchase")}
//                                             </>
//                                         )}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </section>
//             <style>
//                 {`
//                     /* Dark Mode Styles */
//                     .dark-mode .form-control {
//                         background-color: #0a0e27 !important;
//                         border-color: var(--color-border) !important;
//                         color: var(--color-text) !important;
//                     }
                    
//                     .dark-mode .form-control:focus {
//                         background-color: var(--color-card) !important;
//                         border-color: var(--color-primary) !important;
//                         color: var(--color-text) !important;
//                         box-shadow: 0 0 0 0.2rem rgba(26, 35, 126, 0.25) !important;
//                     }
                    
//                     .dark-mode .form-select {
//                         background-color: #0a0e27 !important;
//                         border-color: var(--color-border) !important;
//                         color: var(--color-text) !important;
//                     }
                    
//                     .dark-mode .form-select:focus {
//                         background-color: var(--color-card) !important;
//                         border-color: var(--color-primary) !important;
//                         color: var(--color-text) !important;
//                         box-shadow: 0 0 0 0.2rem rgba(26, 35, 126, 0.25) !important;
//                     }
                    
//                     .dark-mode .form-label {
//                         color: var(--color-text) !important;
//                     }
                    
//                     .dark-mode .card {
//                         background-color: #0a0e27 !important;
//                         border-color: var(--color-border) !important;
//                     }
                    
//                     .dark-mode .card-header {
//                         background-color: var(--color-primary) !important;
//                         border-color: var(--color-border) !important;
//                     }
                    
//                     .dark-mode .text-muted {
//                         color: var(--color-muted) !important;
//                     }
                    
//                     .dark-mode .border {
//                         border-color: var(--color-border) !important;
//                     }
                    
//                     .hover-shadow:hover {
//                         transform: translateY(-2px);
//                         box-shadow: 0 4px 12px rgba(0,0,0,0.1);
//                     }
//                     .text-truncate-2 {
//                         text-overflow: ellipsis;
//                     }
//                     .form-control:focus {
//                         border-color: #000c3d;
//                         box-shadow: 0 0 0 0.2rem rgba(0, 12, 61, 0.25);
//                     }
//                     .form-select:focus {
//                         border-color: #000c3d;
//                         box-shadow: 0 0 0 0.2rem rgba(0, 12, 61, 0.25);
//                     }
                    
//                     /* Quantity Controls Styling */
//                     .quantity-btn {
//                         width: 32px;
//                         height: 32px;
//                         border: 2px solid #000c3d;
//                         background: #fff;
//                         color: #000c3d;
//                         border-radius: 50%;
//                         display: flex;
//                         align-items: center;
//                         justify-content: center;
//                         cursor: pointer;
//                         transition: all 0.3s ease;
//                         font-size: 12px;
//                         font-weight: bold;
//                     }
                    
//                     .quantity-btn:hover:not(:disabled) {
//                         background: #000c3d;
//                         color: #fff;
//                         transform: scale(1.1);
//                         box-shadow: 0 4px 12px rgba(0, 12, 61, 0.3);
//                     }
                    
//                     .quantity-btn:disabled {
//                         border-color: #ccc;
//                         color: #ccc;
//                         cursor: not-allowed;
//                         opacity: 0.5;
//                     }
                    
//                     .quantity-input {
//                         width: 60px;
//                         height: 32px;
//                         border: 2px solid #000c3d;
//                         border-radius: 16px;
//                         text-align: center;
//                         font-weight: bold;
//                         font-size: 14px;
//                         color: #000c3d;
//                         background: #fff;
//                         transition: all 0.3s ease;
//                     }
                    
//                     .quantity-input:focus {
//                         outline: none;
//                         border-color: #1a4b8c;
//                         box-shadow: 0 0 0 0.2rem rgba(0, 12, 61, 0.25);
//                         transform: scale(1.05);
//                     }
                    
//                     .quantity-input::-webkit-inner-spin-button,
//                     .quantity-input::-webkit-outer-spin-button {
//                         -webkit-appearance: none;
//                         margin: 0;
//                     }
                    
//                     .quantity-input[type=number] {
//                         -moz-appearance: textfield;
//                     }
                    
//                     /* Dark mode adjustments */
//                     [data-theme="dark"] .quantity-btn {
//                         background: #2a2a2a;
//                         border-color: #000c3d;
//                         color: #000c3d;
//                     }
                    
//                     [data-theme="dark"] .quantity-btn:hover:not(:disabled) {
//                         background: #000c3d;
//                         color: #fff;
//                     }
                    
//                     [data-theme="dark"] .quantity-input {
//                         background: #2a2a2a;
//                         border-color: #000c3d;
//                         color: #fff;
//                     }
                    
//                     [data-theme="dark"] .quantity-input:focus {
//                         border-color: #1a4b8c;
//                         background: #1a1a1a;
//                     }
                    
//                     /* تحسينات إضافية للتصميم */
//                     .hover-shadow:hover {
//                         transform: translateY(-2px);
//                         box-shadow: 0 8px 25px rgba(0,0,0,0.15);
//                         transition: all 0.3s ease;
//                     }
                    
//                     .card {
//                         transition: all 0.3s ease;
//                     }
                    
//                     .card:hover {
//                         transform: translateY(-2px);
//                         box-shadow: 0 8px 25px rgba(0,0,0,0.1);
//                     }
                    
//                     .form-check:hover {
//                         background-color: #f8f9fa;
//                         border-color: #007bff;
//                     }
                    
//                     .btn-success:hover:not(:disabled) {
//                         transform: translateY(-2px);
//                         box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
//                     }
                    
//                     /* تحسينات الـ Radio Button */
//                     .form-check-input:checked {
//                         background-color: #007bff;
//                         border-color: #007bff;
//                     }
                    
//                     .form-check-input:focus {
//                         border-color: #007bff;
//                         box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
//                     }
                    
//                     .transition-all {
//                         transition: all 0.3s ease;
//                     }
                    
//                     .bg-primary-subtle {
//                         background-color: rgba(0, 123, 255, 0.1) !important;
//                     }
                    
//                     .form-check:hover {
//                         background-color: #f8f9fa;
//                         border-color: #007bff !important;
//                         transform: translateY(-1px);
//                     }
                    
//                     .form-check:hover .rounded-circle {
//                         border-color: #007bff !important;
//                     }
//                 `}
//             </style>
//         </>
//     );
// }

// export default Checkout;



import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDarkMode } from '../../App';
import { useDispatch } from "react-redux";
import { clearCart } from "../../redux/slices/cartSlice";
import { removeCart } from "../../redux/actions/cartAction";

// دالة إنشاء Session ID
const generateSessionId = () => {
    return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

const getSessionId = () => {
    let sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
        sessionId = generateSessionId();
        sessionStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
};
    
// دوال API
const fetchEmployees = async () => {
    const sessionId = getSessionId();
    const token = localStorage.getItem("token");
    const headers = {
        'X-Session-Id': sessionId
    };
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/employees`, {
        method: 'GET',
        headers
    });
    return response.json();
};

const fetchShippingCompanies = async () => {
    const sessionId = getSessionId();
    const token = localStorage.getItem("token");
    const headers = {
        'X-Session-Id': sessionId
    };
    if (token) headers.Authorization = `Bearer ${token}`;
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/shippingCompany`, {
        method: 'GET',
        headers
    });
    return response.json();
};

const fetchPaymentOptions = async () => {
    const sessionId = getSessionId();
    const token = localStorage.getItem("token");
    const headers = {
        'X-Session-Id': sessionId
    };
    if (token) headers.Authorization = `Bearer ${token}`;
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/payment-options`, {
        method: 'GET',
        headers
    });
    return response.json();
};

// دالة جلب ملخص الطلب
const fetchOrderSummary = async (language) => {
    try {
        const sessionId = getSessionId();
        const token = localStorage.getItem("token");
        const headers = {
            'X-Session-Id': sessionId,
            'Accept-Language': language || 'en'
        };
        if (token) headers.Authorization = `Bearer ${token}`;

        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/order/summary`, {
            method: 'GET',
            headers
        });

        if (!response.ok) {
            throw new Error('Failed to fetch order summary');
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error fetching order summary:', error);
        throw error;
    }
};

// دالة إزالة الكوبون
const removeCoupon = async (couponCode, language) => {
    try {
        const sessionId = getSessionId();
        const formData = new FormData();
        formData.append('coupon_code', couponCode);

        const token = localStorage.getItem("token");
        const headers = {
            'X-Session-Id': sessionId,
            'Accept-Language': language || 'en'
        };
        if (token) headers.Authorization = `Bearer ${token}`;

        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/cart/remove-coupon`, {
            method: 'POST',
            headers,
            body: formData
        });

        if (!response.ok) {
            throw new Error('Failed to remove coupon');
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error removing coupon:', error);
        throw error;
    }
};

const submitUserContact = async (formData) => {
    const sessionId = getSessionId();
    const token = localStorage.getItem("token");
    const headers = {
        'X-Session-Id': sessionId
    };
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/user-contact`, {
        method: 'POST',
        headers,
        body: formData
    });
    return response.json();
};

const processCheckout = async (paymentOptionId, contactData, language) => {
    const sessionId = getSessionId();
    const token = localStorage.getItem("token");
    const headers = {
        'X-Session-Id': sessionId,
        'Content-Type': 'application/json',
        'Accept-Language': language || 'en'
    };
    if (token) headers.Authorization = `Bearer ${token}`;

    const payload = {
        payment_option_id: paymentOptionId,
        fullname: contactData.fullname,
        phone: contactData.phone,
        country: contactData.country,
        governorate: contactData.governorate,
        address: contactData.address,
        station: contactData.station,
        details: contactData.address,
        details_shipping: contactData.details_shipping || "-",
        employee_id: contactData.employeeId,
        shipping_company_id: contactData.shippingCompanyId
    };

    const response = await fetch(`${process.env.REACT_APP_BASE_URL}/orders`, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload)
    });
    return response.json();
};

function Checkout() {
    const { t, i18n } = useTranslation("global");
    const navigate = useNavigate();
    const { isDarkMode } = useDarkMode();
    const dispatch = useDispatch();

    // State for form fields
    const [fullname, setFullname] = useState("");
    const [phone, setPhone] = useState("");
    const [country, setCountry] = useState("");
    const [governorate, setGovernorate] = useState("");
    const [address, setAddress] = useState("");
    const [station, setStation] = useState("");
    const [details, setDetails] = useState("");
    const [details_shipping, setDetailsShipping] = useState("");
    const [employeeId, setEmployeeId] = useState("");
    const [shippingCompanyId, setShippingCompanyId] = useState("");
    const [paymentOptionId, setPaymentOptionId] = useState(null);
    const [formError, setFormError] = useState("");
    const [formSuccess, setFormSuccess] = useState("");

    // API Data
    const [employees, setEmployees] = useState([]);
    const [shippingCompanies, setShippingCompanies] = useState([]);
    const [paymentOptions, setPaymentOptions] = useState([]);
    const [isLoadingEmployees, setIsLoadingEmployees] = useState(false);
    const [isLoadingShipping, setIsLoadingShipping] = useState(false);
    const [isLoadingPayment, setIsLoadingPayment] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isProcessingCheckout, setIsProcessingCheckout] = useState(false);

    // Cart data from API
    const [cartItems, setCartItems] = useState([]);
    const [cartTotals, setCartTotals] = useState({ subtotal: 0, discount: 0, shipping: 0, total: 0 });
    const [isLoadingCart, setIsLoadingCart] = useState(true);

    // Order summary state
    const [showOrderSummary, setShowOrderSummary] = useState(false);
    const [orderData, setOrderData] = useState(null);
    const [contactSubmitted, setContactSubmitted] = useState(false);
    const [orderSummary, setOrderSummary] = useState(null);
    const [isLoadingSummary, setIsLoadingSummary] = useState(false);
    const [isRemovingCoupon, setIsRemovingCoupon] = useState(false);
    
    // Phone validation state
    const [phoneError, setPhoneError] = useState("");

    // دالة التحقق من رقم الهاتف
    const validatePhone = (phoneNumber) => {
        if (!phoneNumber) {
            setPhoneError("");
            return true;
        }
        
        const phoneRegex = /^[0-9+\-\s()]+$/;
        if (!phoneRegex.test(phoneNumber)) {
            setPhoneError(t("checkout.phoneValidation"));
            return false;
        }
        
        const cleanPhone = phoneNumber.replace(/[^0-9]/g, '');
        if (cleanPhone.length < 7 || cleanPhone.length > 15) {
            setPhoneError(t("checkout.phoneLength"));
            return false;
        }
        
        setPhoneError("");
        return true;
    };

    // دالة تحديث رقم الهاتف مع التحقق
    const handlePhoneChange = (e) => {
        const value = e.target.value;
        // السماح فقط بالأرقام والرموز المسموحة
        const allowedChars = /^[0-9+\-\s()]*$/;
        if (allowedChars.test(value)) {
            setPhone(value);
            validatePhone(value);
        }
    };

    // دالة منع إدخال أحرف غير مسموحة
    const handlePhoneKeyPress = (e) => {
        const allowedChars = /[0-9+\-\s()]/;
        if (!allowedChars.test(e.key) && !['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
            e.preventDefault();
        }
    };

    // دالة جلب ملخص الطلب
    const loadOrderSummary = async () => {
        try {
            setIsLoadingSummary(true);
            const summaryData = await fetchOrderSummary(i18n.language);
            if (summaryData.status && summaryData.data) {
                setOrderSummary(summaryData.data);
            }
        } catch (error) {
            console.error('Error loading order summary:', error);
        } finally {
            setIsLoadingSummary(false);
        }
    };

    // دالة حذف الكوبون
    const handleRemoveCoupon = async () => {
        if (!orderSummary?.coupon_code) {
            return;
        }

        try {
            setIsRemovingCoupon(true);
            const result = await removeCoupon(orderSummary.coupon_code, i18n.language);
            
            if (result.status) {
                toast.success(result.message || t("cart.couponApplied"));
                // إعادة تحميل ملخص الطلب بعد حذف الكوبون
                await loadOrderSummary();
            }
        } catch (error) {
            console.error('Error removing coupon:', error);
            toast(t("cart.errorRemovingCoupon"));
        } finally {
            setIsRemovingCoupon(false);
        }
    };

    // تحميل البيانات من API
    useEffect(() => {
        const loadData = async () => {
            try {
                // تحميل السلة من API
                const sessionId = getSessionId();
                const token = localStorage.getItem("token");
                const headers = {
                    'X-Session-Id': sessionId
                };
                if (token) headers.Authorization = `Bearer ${token}`;

                const cartResponse = await fetch(`${process.env.REACT_APP_BASE_URL}/cart`, {
                    method: 'GET',
                    headers
                });
                const cartData = await cartResponse.json();
                
                if (cartData.status && cartData.data) {
                    setCartItems(cartData.data.items || []);
                    setCartTotals(cartData.data.totals || { subtotal: 0, discount: 0, shipping: 0, total: 0 });
                }
                
                // تحميل الموظفين
                setIsLoadingEmployees(true);
                const employeesData = await fetchEmployees();
                if (employeesData.status && employeesData.data) {
                    setEmployees(employeesData.data);
                }
                setIsLoadingEmployees(false);
                
                // تحميل شركات الشحن
                setIsLoadingShipping(true);
                const shippingData = await fetchShippingCompanies();
                if (shippingData.status && shippingData.data) {
                    setShippingCompanies(shippingData.data);
                }
                setIsLoadingShipping(false);
                
                // تحميل خيارات الدفع
                setIsLoadingPayment(true);
                const paymentData = await fetchPaymentOptions();
                if (paymentData.status && paymentData.data) {
                    setPaymentOptions(paymentData.data);
                    
                    // اختيار الخيار الوحيد تلقائياً إذا وجد
                    if (paymentData.data.length === 1) {
                        setPaymentOptionId(paymentData.data[0].id);
                    }
                }
                setIsLoadingPayment(false);
                
                // تحميل ملخص الطلب
                await loadOrderSummary();
                
            } catch (error) {
                console.error('Error loading data:', error);
                toast(t("common.error"));
                setIsLoadingEmployees(false);
                setIsLoadingShipping(false);
                setIsLoadingPayment(false);
            } finally {
                setIsLoadingCart(false);
            }
        };
        
        loadData();
    }, []);

    // دالة إرسال بيانات الاتصال
    const handleSubmitContact = async (e) => {
        e.preventDefault();
        setFormError("");
        setFormSuccess("");
        
        // تحقق من ملء الحقول المطلوبة (details غير مطلوب)
        if (!fullname || !phone || !country || !governorate || !address || !station || !employeeId || !shippingCompanyId) {
            setFormError(t("checkout.requiredFields"));
            toast(t("checkout.requiredFields"), { autoClose: 1500 });
            return;
        }

        // تحقق من صحة رقم الهاتف
        if (!validatePhone(phone)) {
            setFormError(phoneError);
            toast(phoneError, { autoClose: 1500 });
            return;
        }

        // تحقق من وجود منتجات في السلة
        if (cartItems.length === 0) {
            setFormError(t("checkout.emptyCartMessage"));
            toast(t("checkout.emptyCartMessage"), { autoClose: 1500 });
            return;
        }
        
        try {
            setIsSubmitting(true);
            
            // إعداد FormData
            const formData = new FormData();
            formData.append('employee_id', employeeId);
            formData.append('phone', phone);
            formData.append('shipping_company_id', shippingCompanyId);
            formData.append('details', address);
            formData.append('details_shipping', details_shipping || "-");
            formData.append('station', station);
            formData.append('governorate', governorate);
            formData.append('address', address);
            formData.append('fullname', fullname);
            formData.append('country', country);

            // إرسال البيانات
            const result = await submitUserContact(formData);
            
            if (result.status) {
                toast.success(result.message || t("checkout.contactSuccess"));
                setFormSuccess(t("checkout.contactSuccess"));
                
                // حفظ بيانات الطلب
                setOrderData({
                    contactData: {
                        fullname,
                        phone,
                        country,
                        governorate,
                        address,
                        station,
                        details: address,
                        details_shipping,
                        employee: employees.find(emp => emp.id == employeeId),
                        shippingCompany: shippingCompanies.find(comp => comp.id == shippingCompanyId)
                    },
                    cartItems,
                    cartTotals
                });
                
                // تمييز أن بيانات الاتصال تم إرسالها
                setContactSubmitted(true);
                
            } else {
                setFormError(result.message || t("checkout.contactError"));
                toast(result.message || t("checkout.contactError"));
            }
            
        } catch (error) {
            console.error('Error submitting contact:', error);
            setFormError(t("checkout.contactError"));
            toast(t("checkout.contactError"));
        } finally {
            setIsSubmitting(false);
        }
    };

    // دالة إظهار عملية الدفع
    const handleShowCheckout = async () => {
        // تحميل ملخص الطلب قبل إظهار عملية الدفع
        await loadOrderSummary();
        setShowOrderSummary(true);
    };

    // دالة إتمام عملية الشراء
    const handleProcessCheckout = async () => {
        if (!paymentOptionId) {
            toast(t("checkout.selectPaymentFirst"));
            return;
        }

        try {
            setIsProcessingCheckout(true);
            
            const result = await processCheckout(paymentOptionId, {
                fullname,
                phone,
                country,
                governorate,
                address,
                station,
                details_shipping,
                employeeId,
                shippingCompanyId
            }, i18n.language);
            
            if (result.status) {
                // عرض رسالة النجاح بالعربية
                const orderId = result.data?.order_id || result.data?.id || "";
                let successMessage = result.message === "order.created"
                    ? t("checkout.orderCreated")
                    : (result.message || t("checkout.orderCreated"));
                
                // If we have an order ID and it's not already in the message, append it
                if (orderId && !successMessage.includes(orderId.toString())) {
                    successMessage = `${successMessage} ${orderId}`;
                }
                
                toast.success(successMessage, {
                    autoClose: 5000,
                    position: "top-center"
                });

                // Clear cart from back-end and front-end
                await dispatch(removeCart(i18n.language));
                dispatch(clearCart());
                setTimeout(() => {
                    navigate('/');
                }, 2000);
                
            } else {
                toast(result.message || t("checkout.checkoutError"));
            }
            
        } catch (error) {
            console.error('Error processing checkout:', error);
            toast(t("checkout.checkoutError"));
        } finally {
            setIsProcessingCheckout(false);
        }
    };

    // حساب المجاميع من API
    const subtotal = cartTotals.subtotal || cartTotals.sub_total || 0;
    const discount = cartTotals.discount || cartTotals.discount_amount || 0;
    const shippingCost = cartTotals.shipping || cartTotals.shipping_cost || 0;
    const finalTotal = cartTotals.total || cartTotals.final_total || 0;

    if (isLoadingCart) {
        return (
            <div className="container text-center my-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">{t("checkout.loadingCart")}</span>
                </div>
                <p className="mt-3">{t("checkout.loadingCart")}</p>
            </div>
        );
    }

    if (cartItems.length === 0) {
        return (
            <div className="container text-center my-5">
                <i className="fas fa-shopping-cart fa-3x mb-3 text-muted"></i>
                <h4 className="text-muted">{t("checkout.emptyCartMessage")}</h4>
                <p className="text-muted">{t("checkout.emptyCartDescription")}</p>
                <button 
                    className="btn btn-primary"
                    onClick={() => navigate('/')}
                >
                    {t("checkout.backToShopping")}
                </button>
            </div>
        );
    }

    return (
        <>

            <div className={`breadcrumb-box text-center py-5 mb-4 rounded ${isDarkMode ? 'dark-mode' : ''}`} style={{ background: isDarkMode ? 'var(--color-card)' : "#000c3d0D" }} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                <h4 className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("checkout.title", "إتمام الطلب")}</h4>
                <p className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("checkout.breadcrumb", "الرئيسية / السلة / إتمام الطلب")}</p>
            </div>

            <section className={`checkout container mb-5 ${isDarkMode ? 'dark-mode' : ''}`} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                <div className="row">
                    {!showOrderSummary ? (
                        <form className="col-md-12 row" onSubmit={handleSubmitContact}>
                            <div className={`col-md-7 border rounded p-4 ${isDarkMode ? 'dark-mode' : ''}`} style={{
                                backgroundColor: isDarkMode ? 'var(--color-card)' : undefined,
                                borderColor: isDarkMode ? 'var(--color-border)' : undefined
                            }}>
                                <h6 className="fw-bold mb-3" style={{ color: isDarkMode ? 'var(--color-primary)' : undefined }}>{t("checkout.contactInfo", "معلومات جهة الاتصال")}</h6>
                                
                                {/* الاسم الكامل */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("checkout.fullname", "الاسم الكامل")} *</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder={t("checkout.fullnamePlaceholder", "أدخل الاسم الكامل")} 
                                        value={fullname} 
                                        onChange={e => setFullname(e.target.value)} 
                                        required
                                        style={{
                                            backgroundColor: isDarkMode ? 'var(--color-card)' : undefined,
                                            borderColor: isDarkMode ? 'var(--color-border)' : undefined,
                                            color: isDarkMode ? 'var(--color-text)' : undefined
                                        }}
                                    />
                                </div>
                            
                                {/* رقم الهاتف */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("checkout.phone", "رقم الهاتف")} *</label>
                                    <input 
                                        type="tel" 
                                        className={`form-control ${i18n.language === 'ar' ? 'text-end ' : 'text-start '} ${phoneError ? 'is-invalid' : ''}`}
                                        placeholder={t("checkout.phonePlaceholder", "أدخل رقم الهاتف")}
                                        value={phone} 
                                        onChange={handlePhoneChange}
                                        onKeyPress={handlePhoneKeyPress}
                                        required
                                        style={{
                                            backgroundColor: isDarkMode ? 'var(--color-card)' : undefined,
                                            borderColor: isDarkMode ? 'var(--color-border)' : undefined,
                                            color: isDarkMode ? 'var(--color-text)' : undefined
                                        }}
                                    />
                                    {phoneError && (
                                        <div className="invalid-feedback">
                                            {phoneError}
                                        </div>
                                    )}
                                    <div className="form-text" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>
                                        {t("checkout.phoneExample")}
                                    </div>
                                </div>
                            
                                {/* البلد */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("checkout.country", "البلد")} *</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder={t("checkout.countryPlaceholder", "أدخل اسم البلد")} 
                                        value={country} 
                                        onChange={e => setCountry(e.target.value)} 
                                        required
                                    />
                                </div>
                            
                                {/* المحافظة */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("checkout.governorate", "المحافظة")} *</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder={t("checkout.governoratePlaceholder", "أدخل اسم المحافظة")} 
                                        value={governorate} 
                                        onChange={e => setGovernorate(e.target.value)} 
                                        required
                                    />
                                </div>
                            
                                {/* العنوان - يرسل إلى details */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("checkout.address", "العنوان")} *</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder={t("checkout.addressPlaceholder", "أدخل العنوان")} 
                                        value={address} 
                                        onChange={e => setAddress(e.target.value)} 
                                        required
                                    />
                                </div>
                            
                                {/* المحطة */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("checkout.station", "المحطة")} *</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder={t("checkout.stationPlaceholder", "أدخل اسم المحطة")} 
                                        value={station} 
                                        onChange={e => setStation(e.target.value)} 
                                        required
                                    />
                                </div>
                                
                                {/* الموظف */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("checkout.employee", "الموظف")} *</label>
                                    <select 
                                        className="form-select" 
                                        value={employeeId} 
                                        onChange={e => setEmployeeId(e.target.value)}
                                        required
                                        disabled={isLoadingEmployees}
                                    >
                                        <option value="">{isLoadingEmployees ? t("checkout.loadingEmployees") : t("checkout.selectEmployee")}</option>
                                        {employees.map(employee => (
                                            <option key={employee.id} value={employee.id}>
                                                {employee.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            
                                {/* شركة الشحن */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("checkout.shippingCompany", "شركة الشحن")} *</label>
                                    <select 
                                        className="form-select" 
                                        value={shippingCompanyId} 
                                        onChange={e => setShippingCompanyId(e.target.value)}
                                        required
                                        disabled={isLoadingShipping}
                                    >
                                        <option value="">{isLoadingShipping ? t("checkout.loadingShipping") : t("checkout.selectShippingCompany")}</option>
                                        {shippingCompanies.map(company => (
                                            <option key={company.id} value={company.id}>
                                                {company.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                
                                {/* تفاصيل إضافية - يرسل إلى details_shipping */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("checkout.details", "تفاصيل إضافية")}</label>
                                    <textarea 
                                        className="form-control" 
                                        rows="3" 
                                        placeholder={t("checkout.detailsPlaceholder", "تفاصيل إضافية للطلب")} 
                                        value={details_shipping} 
                                        onChange={e => setDetailsShipping(e.target.value)}
                                    ></textarea>
                                </div>
                            </div>
                        
                            <div className="col-md-5">
                                <div className="border rounded p-3 mb-3">
                                    <h6 className="fw-bold mb-3">{t("checkout.orderSummary", "ملخص الطلب")}</h6>
                                    
                                    <div className={`order-summary rounded p-4 shadow-sm ${isDarkMode ? 'dark-mode' : 'bg-light'}`} style={{
                                        backgroundColor: isDarkMode ? '#0a0e27' : undefined,
                                        border: isDarkMode ? '1px solid var(--color-border)' : undefined
                                    }}>
                                        
                                        {/* عرض ملخص الطلب من API إذا كان متوفراً */}
                                        {orderSummary ? (
                                            <>
                                                {/* المنتجات */}
                                                {orderSummary.products && orderSummary.products.length > 0 && (
                                                    <div className="mb-3">
                                                        <h6 className="fw-bold mb-2" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("cart.products")}:</h6>
                                                        {orderSummary.products.map((product, index) => (
                                                            <div key={index} className="d-flex justify-content-between align-items-center mb-2 p-2" style={{
                                                                backgroundColor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                                                                borderRadius: '8px'
                                                            }}>
                                                                <div className="d-flex align-items-center">
                                                                    <img 
                                                                        src={product.image} 
                                                                        alt={product.name}
                                                                        style={{ width: '40px', height: '40px', borderRadius: '8px', marginRight: '10px' }}
                                                                    />
                                                                    <div>
                                                                        <div className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>
                                                                            {product.name}
                                                                        </div>
                                                                        {product.code && (
                                                                            <div className="text-muted small" style={{ fontSize: '0.8rem', color: isDarkMode ? 'var(--color-muted)' : undefined }}>
                                                                                {t('product.code')}: {product.code}
                                                                            </div>
                                                                        )}
                                                                        {product.variant_name && (
                                                                            <small className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>
                                                                                {t("cart.variant")} {product.variant_name}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="text-end">
                                                                    <div className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>
                                                                        {product.quantity} × {(product.unit_price || product.price || 0)} {t("cart.currency")}
                                                                    </div>
                                                                    <div className="text-warning fw-bold">
                                                                        = {(product.total || product.line_total || (product.unit_price || product.price || 0) * product.quantity)} {t("cart.currency")}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* كود الكوبون */}
                                                {orderSummary.coupon_code && (
                                                    <div className="d-flex justify-content-between align-items-center mb-2 p-2" style={{
                                                        backgroundColor: isDarkMode ? 'rgba(40, 167, 69, 0.1)' : 'rgba(40, 167, 69, 0.1)',
                                                        borderRadius: '8px',
                                                        border: '1px solid rgba(40, 167, 69, 0.3)'
                                                    }}>
                                                        <span className="text-success fw-bold">{t("cart.couponCode")}: {orderSummary.coupon_code}</span>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={handleRemoveCoupon}
                                                            disabled={isRemovingCoupon}
                                                            style={{
                                                                padding: '4px 8px',
                                                                fontSize: '12px',
                                                                borderRadius: '4px'
                                                            }}
                                                        >
                                                            {isRemovingCoupon ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm mx-1" role="status" aria-hidden="true"></span>
                                                                    {t("cart.removing")}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fas fa-times mx-1"></i>
                                                                    {t("cart.removeCoupon")}
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                )}

                                                {/* المجموع الفرعي */}
                                                <div className="d-flex justify-content-between mb-2">
                                                    <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("cart.subtotal")}</span>
                                                    <span className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>
                                                        {(orderSummary.subtotal || orderSummary.sub_total)} {t("cart.currency")}
                                                    </span>
                                                </div>

                                                {/* مبلغ الخصم */}
                                                {(orderSummary.discount_amount > 0 || orderSummary.discount > 0) && (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("cart.discount")}</span>
                                                        <span className="text-success fw-bold">
                                                            - {(orderSummary.discount_amount || orderSummary.discount)} {t("cart.currency")}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* الإجمالي النهائي */}
                                                <div className="d-flex justify-content-between pt-2 mt-2 border-top" style={{ borderTop: isDarkMode ? '1px solid var(--color-border)' : undefined }}>
                                                    <span className="h6 mb-0" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("cart.total")}</span>
                                                    <span className="h5 mb-0 text-warning fw-bold">
                                                        {(orderSummary.final_total || orderSummary.total)} {t("cart.currency")}
                                                    </span>
                                                </div>
                                            </>
                                        ) : (
                                            /* عرض البيانات المحلية إذا لم يكن ملخص الطلب متوفراً */
                                            <>
                                                {/* المجموع */}
                                                <div className="d-flex justify-content-between mb-3">
                                                    <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("checkout.subtotal", "المجموع")}</span>
                                                    <span className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{subtotal.toFixed(2)} {t("cart.currency")}</span>
                                                </div>

                                                {/* الخصم */}
                                                {discount > 0 && (
                                                    <div className="d-flex justify-content-between mb-3">
                                                        <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("checkout.discount", "الخصم")}</span>
                                                        <span className="fw-bold text-success">-{discount.toFixed(2)} {t("cart.currency")}</span>
                                                    </div>
                                                )}

                                                {/* الشحن */}
                                                {shippingCost > 0 && (
                                                    <div className="d-flex justify-content-between mb-3">
                                                        <span className="text-muted" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>{t("checkout.shipping", "الشحن")}</span>
                                                        <span className="fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{shippingCost.toFixed(2)} {t("cart.currency")}</span>
                                                    </div>
                                                )}

                                                {/* الإجمالي */}
                                                <div className="d-flex justify-content-between pt-3 mt-3 border-top" style={{ borderTop: isDarkMode ? '1px solid var(--color-border)' : undefined }}>
                                                    <span className="h6 mb-0" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>{t("checkout.total", "الإجمالي")}</span>
                                                    <div className="d-flex flex-column align-items-end">
                                                        <span className="h5 mb-0 fw-bold" style={{ color: isDarkMode ? 'var(--color-text)' : "blue" }}>
                                                            {finalTotal.toFixed(2)} {t("cart.currency")}
                                                        </span>
                                                        <small className="text-muted mt-1" style={{ color: isDarkMode ? 'var(--color-muted)' : undefined }}>
                                                            {t("checkout.includingVAT", "شامل الضريبة")}
                                                        </small>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {/* Loading state لملخص الطلب */}
                                        {isLoadingSummary && (
                                            <div className="text-center mt-3">
                                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <span className="ms-2" style={{ color: isDarkMode ? 'var(--color-text)' : undefined }}>
                                                    {t("cart.updatingSummary")}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* رسائل الخطأ/النجاح */}
                                {formError && <div className="alert alert-danger text-center">{formError}</div>}
                                {formSuccess && <div className="alert alert-success text-center">{formSuccess}</div>}
                                {!contactSubmitted && (
                                <button 
                                    type="submit" 
                                    className="btn w-100 text-white fw-bold py-2" 
                                    style={{ backgroundColor: "#000c3d" }}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                            {t("checkout.submitting")}
                                        </>
                                    ) : (
                                        t("checkout.submitContact")
                                    )}
                                </button>
                                )}

                                {/* زر إظهار عملية الدفع - يظهر فقط بعد إرسال بيانات الاتصال بنجاح */}
                                {contactSubmitted && !showOrderSummary && (
                                    <button 
                                        type="button"
                                        className="btn w-100 text-white fw-bold py-2 mt-3" 
                                        style={{ backgroundColor: "#28a745" }}
                                        onClick={handleShowCheckout}
                                    >
                                        <i className="fas fa-credit-card mx-2"></i>
                                        {t("checkout.proceedToPayment", "المتابعة للدفع")}
                                    </button>
                                )}
                            </div>
                        </form>
                    ) : (
                        /* ملخص الطلب بعد الإرسال الناجح */
                        <div className="col-md-12">
                            <div className="border rounded p-4 mb-4 shadow-sm">
                                <h5 className="fw-bold text-success mb-4">
                                    <i className="fas fa-check-circle mx-2"></i>
                                    {t("checkout.contactSubmitted")}
                                </h5>
                                
                                {/* بيانات الاتصال */}
                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <div className="card border-0 bg-light">
                                            <div className="card-header bg-primary text-white">
                                                <h6 className="fw-bold mb-0">
                                                    <i className="fas fa-user mx-2"></i>
                                                    {t("checkout.contactData")}
                                                </h6>
                                            </div>
                                            <div className="card-body">
                                                <div className="row g-3">
                                                    <div className="col-12">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-user text-primary mx-3"></i>
                                                            <div>
                                                                <small className="text-muted">{t("checkout.name")}</small>
                                                                <div className="fw-bold">{orderData?.contactData?.fullname}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-phone text-primary mx-3"></i>
                                                            <div>
                                                                <small className="text-muted">{t("checkout.phoneNumber")}</small>
                                                                <div className="fw-bold">{orderData?.contactData?.phone}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-globe text-primary mx-3"></i>
                                                            <div>
                                                                <small className="text-muted">{t("checkout.countryName")}</small>
                                                                <div className="fw-bold">{orderData?.contactData?.country}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-map-marker-alt text-primary mx-3"></i>
                                                            <div>
                                                                <small className="text-muted">{t("checkout.governorateName")}</small>
                                                                <div className="fw-bold">{orderData?.contactData?.governorate}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-home text-primary mx-3"></i>
                                                            <div>
                                                                <small className="text-muted">{t("checkout.addressName")}</small>
                                                                <div className="fw-bold">{orderData?.contactData?.address}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-train text-primary mx-3"></i>
                                                            <div>
                                                                <small className="text-muted">{t("checkout.stationName")}</small>
                                                                <div className="fw-bold">{orderData?.contactData?.station}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-user-tie text-primary mx-3"></i>
                                                            <div>
                                                                <small className="text-muted">{t("checkout.employeeName")}</small>
                                                                <div className="fw-bold">{orderData?.contactData?.employee?.name}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-truck text-primary mx-3"></i>
                                                            <div>
                                                                <small className="text-muted">{t("checkout.shippingCompanyName")}</small>
                                                                <div className="fw-bold">{orderData?.contactData?.shippingCompany?.name}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {orderData?.contactData?.details && (
                                                        <div className="col-12">
                                                            <div className="d-flex align-items-start">
                                                                <i className="fas fa-info-circle text-primary mx-3 mt-1"></i>
                                                                <div>
                                                                    <small className="text-muted">{t("checkout.additionalDetails")}</small>
                                                                    <div className="fw-bold">{orderData.contactData.details}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card border-0 bg-light">
                                            <div className="card-header bg-success text-white">
                                                <h6 className="fw-bold mb-0">
                                                    <i className="fas fa-shopping-cart mx-2"></i>
                                                    {t("checkout.orderData")}
                                                </h6>
                                            </div>
                                            <div className="card-body">
                                                {/* عرض ملخص الطلب من API إذا كان متوفراً */}
                                                {orderSummary ? (
                                                    <>
                                                        {/* المنتجات */}
                                                        {orderSummary.products && orderSummary.products.length > 0 && (
                                                            <div className="mb-3">
                                                                <h6 className="fw-bold mb-2">{t("cart.products")}:</h6>
                                                                {orderSummary.products.map((product, index) => (
                                                                    <div key={index} className="d-flex justify-content-between align-items-center mb-2 p-2" style={{
                                                                        backgroundColor: 'rgba(0,0,0,0.05)',
                                                                        borderRadius: '8px'
                                                                    }}>
                                                                        <div className="d-flex align-items-center">
                                                                            <img 
                                                                                src={product.image} 
                                                                                alt={product.name}
                                                                                style={{ width: '30px', height: '30px', borderRadius: '6px', marginRight: '8px' }}
                                                                            />
                                                                            <div>
                                                                                <div className="fw-bold small">
                                                                                    {product.name}
                                                                                </div>
                                                                                {product.code && (
                                                                                    <div className="text-muted small" style={{ fontSize: '0.8rem' }}>
                                                                                        {t('product.code')}: {product.code}
                                                                                    </div>
                                                                                )}
                                                                                {product.variant_name && (
                                                                                    <small className="text-muted">
                                                                                        {t("cart.variant")} {product.variant_name}
                                                                                    </small>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-end">
                                                                            <div className="fw-bold small">
                                                                                {product.quantity} × {product.unit_price} {t("cart.currency")}
                                                                            </div>
                                                                            <div className="text-warning fw-bold small">
                                                                                = {product.total} {t("cart.currency")}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {/* كود الكوبون */}
                                                        {orderSummary.coupon_code && (
                                                            <div className="d-flex justify-content-between align-items-center mb-2 p-2" style={{
                                                                backgroundColor: 'rgba(40, 167, 69, 0.1)',
                                                                borderRadius: '8px',
                                                                border: '1px solid rgba(40, 167, 69, 0.3)'
                                                            }}>
                                                                <span className="text-success fw-bold small">{t("cart.couponCode")}: {orderSummary.coupon_code}</span>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    onClick={handleRemoveCoupon}
                                                                    disabled={isRemovingCoupon}
                                                                    style={{
                                                                        padding: '2px 6px',
                                                                        fontSize: '10px',
                                                                        borderRadius: '4px'
                                                                    }}
                                                                >
                                                                    {isRemovingCoupon ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm mx-1" role="status" aria-hidden="true"></span>
                                                                            {t("cart.removing")}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <i className="fas fa-times mx-1"></i>
                                                                            {t("cart.removeCoupon")}
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        )}

                                                        {/* المجموع الفرعي */}
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <span className="text-muted">{t("cart.subtotal")}</span>
                                                            <span className="fw-bold">
                                                                {(orderSummary.subtotal || orderSummary.sub_total)} {t("cart.currency")}
                                                            </span>
                                                        </div>

                                                        {/* مبلغ الخصم */}
                                                        {(orderSummary.discount_amount > 0 || orderSummary.discount > 0) && (
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <span className="text-muted">{t("cart.discount")}</span>
                                                                <span className="text-success fw-bold">
                                                                    - {(orderSummary.discount_amount || orderSummary.discount)} {t("cart.currency")}
                                                                </span>
                                                            </div>
                                                        )}

                                                        {/* الإجمالي النهائي */}
                                                        <hr />
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="h6 mb-0">{t("cart.total")}</span>
                                                            <span className="h5 mb-0 fw-bold text-primary">
                                                                {(orderSummary.final_total || orderSummary.total)} {t("cart.currency")}
                                                            </span>
                                                        </div>
                                                    </>
                                                ) : (
                                                    /* عرض البيانات المحلية إذا لم يكن ملخص الطلب متوفراً */
                                                    <>
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <span className="text-muted">{t("cart.subtotal")}</span>
                                                            <span className="fw-bold">{(orderData?.cartTotals?.subtotal || orderData?.cartTotals?.sub_total || 0).toFixed(2)} {t("cart.currency")}</span>
                                                        </div>
                                                        {(orderData?.cartTotals?.discount > 0 || orderData?.cartTotals?.discount_amount > 0) && (
                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                <span className="text-muted">{t("cart.discount")}</span>
                                                                <span className="fw-bold text-success">-{(orderData?.cartTotals?.discount || orderData?.cartTotals?.discount_amount || 0).toFixed(2)} {t("cart.currency")}</span>
                                                            </div>
                                                        )}
                                                        {(orderData?.cartTotals?.shipping > 0 || orderData?.cartTotals?.shipping_cost > 0) && (
                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                <span className="text-muted">{t("cart.shipping")}</span>
                                                                <span className="fw-bold">{(orderData?.cartTotals?.shipping || orderData?.cartTotals?.shipping_cost || 0).toFixed(2)} {t("cart.currency")}</span>
                                                            </div>
                                                        )}
                                                        <hr />
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="h6 mb-0">{t("cart.total")}</span>
                                                            <span className="h5 mb-0 fw-bold text-primary">{(orderData?.cartTotals?.total || orderData?.cartTotals?.final_total || 0).toFixed(2)} {t("cart.currency")}</span>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* خيارات الدفع */}
                            <div className="card border-0 shadow-sm mb-4">
                                <div className="card-header text-white" style={{ backgroundColor: '#000c3d' }}>
                                    <h6 className="fw-bold mb-0">
                                        <i className="fas fa-credit-card mx-2"></i>
                                        {t("checkout.paymentOptions", "خيارات الدفع")}
                                    </h6>
                                </div>
                                <div className="card-body">
                                    {isLoadingPayment ? (
                                        <div className="text-center py-4">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">{t("checkout.loadingPayment")}</span>
                                            </div>
                                            <p className="mt-2 text-muted">{t("checkout.loadingPayment")}</p>
                                        </div>
                                    ) : (
                                        <div className="row g-3">
                                            {paymentOptions.map((option, idx) => (
                                                <div className="col-12" key={option.id || idx}>
                                                    <div 
                                                        className={`form-check p-4 border rounded hover-shadow transition-all ${
                                                            paymentOptionId === option.id 
                                                                ? 'border-primary bg-primary-subtle' 
                                                                : 'border-light'
                                                        }`} 
                                                        style={{ 
                                                            cursor: 'pointer',
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onClick={() => setPaymentOptionId(option.id)}
                                                    >
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="d-flex align-items-center flex-grow-1">
                                                                 <div className="mx-3 order-1">
                                                                    <div className="fw-bold h6 mb-0">
                                                                        {i18n.language === 'ar' 
                                                                            ? (option.name_ar || option.name || (option.id === 1 ? "الدفع عند الاستلام" : option.id === 2 ? "تحويل بنكي" : "بطاقة بانكية")) 
                                                                            : (option.name_en || option.name || (option.id === 1 ? "Cash on Delivery" : option.id === 2 ? "Bank Transfer" : "Bank Card"))
                                                                        }
                                                                    </div>
                                                                    <small className="text-muted">{t("checkout.selectPaymentMethod")}</small>
                                                                </div>
                                                                <i className={`fas ${
                                                                    (option.name_en?.toLowerCase().includes('cash') || option.name_ar?.includes('استلام') || option.id === 1) ? 'fa-money-bill-wave' :
                                                                    (option.name_en?.toLowerCase().includes('bank') || option.name_ar?.includes('تحويل') || option.id === 2) ? 'fa-university' :
                                                                    'fa-credit-card'
                                                                } text-primary mx-3 order-2`} style={{ fontSize: '1.5rem' }}></i>
                                                            </div>

                                                            <div className="mx-3 order-lg-last">
                                                                <div className="position-relative">
                                                                    <input 
                                                                        className="form-check-input position-absolute" 
                                                                        type="radio" 
                                                                        name="paymentOption" 
                                                                        id={`payopt${option.id || idx}`} 
                                                                        value={option.id} 
                                                                        checked={paymentOptionId === option.id} 
                                                                        onChange={() => setPaymentOptionId(option.id)} 
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            margin: 0,
                                                                            opacity: 0,
                                                                            zIndex: 2
                                                                        }}
                                                                    />
                                                                    <div 
                                                                        className={`rounded-circle border d-flex align-items-center justify-content-center ${
                                                                            paymentOptionId === option.id 
                                                                                ? 'border-primary bg-primary' 
                                                                                : 'border-secondary'
                                                                        }`}
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            position: 'relative',
                                                                            zIndex: 1
                                                                        }}
                                                                    >
                                                                        {paymentOptionId === option.id && (
                                                                            <i className="fas fa-check text-white" style={{ fontSize: '10px' }}></i>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* زر إتمام الشراء */}
                            <div className="d-grid">
                                <button 
                                    className="btn btn-success btn-lg fw-bold py-3 shadow-sm" 
                                    onClick={handleProcessCheckout}
                                    disabled={!paymentOptionId || isProcessingCheckout}
                                    style={{ 
                                        backgroundColor: isProcessingCheckout ? "#6c757d" : "#28a745",
                                        border: "none",
                                        borderRadius: "10px",
                                        fontSize: "1.1rem"
                                    }}
                                >
                                    {isProcessingCheckout ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                            {t("checkout.processingCheckout")}
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-check-circle mx-2"></i>
                                            {t("checkout.completePurchase")}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
            <style>
                {`
                    /* Dark Mode Styles */
                    .dark-mode .form-control {
                        background-color: #0a0e27 !important;
                        border-color: var(--color-border) !important;
                        color: var(--color-text) !important;
                    }
                    
                    .dark-mode .form-control:focus {
                        background-color: var(--color-card) !important;
                        border-color: var(--color-primary) !important;
                        color: var(--color-text) !important;
                        box-shadow: 0 0 0 0.2rem rgba(26, 35, 126, 0.25) !important;
                    }
                    
                    .dark-mode .form-select {
                        background-color: #0a0e27 !important;
                        border-color: var(--color-border) !important;
                        color: var(--color-text) !important;
                    }
                    
                    .dark-mode .form-select:focus {
                        background-color: var(--color-card) !important;
                        border-color: var(--color-primary) !important;
                        color: var(--color-text) !important;
                        box-shadow: 0 0 0 0.2rem rgba(26, 35, 126, 0.25) !important;
                    }
                    
                    .dark-mode .form-label {
                        color: var(--color-text) !important;
                    }
                    
                    .dark-mode .card {
                        background-color: #0a0e27 !important;
                        border-color: var(--color-border) !important;
                    }
                    
                    .dark-mode .card-header {
                        background-color: var(--color-primary) !important;
                        border-color: var(--color-border) !important;
                    }
                    
                    .dark-mode .text-muted {
                        color: var(--color-muted) !important;
                    }
                    
                    .dark-mode .border {
                        border-color: var(--color-border) !important;
                    }
                    
                    .hover-shadow:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                    }
                    .text-truncate-2 {
                        text-overflow: ellipsis;
                    }
                    .form-control:focus {
                        border-color: #000c3d;
                        box-shadow: 0 0 0 0.2rem rgba(0, 12, 61, 0.25);
                    }
                    .form-select:focus {
                        border-color: #000c3d;
                        box-shadow: 0 0 0 0.2rem rgba(0, 12, 61, 0.25);
                    }
                    
                    /* Quantity Controls Styling */
                    .quantity-btn {
                        width: 32px;
                        height: 32px;
                        border: 2px solid #000c3d;
                        background: #fff;
                        color: #000c3d;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        font-size: 12px;
                        font-weight: bold;
                    }
                    
                    .quantity-btn:hover:not(:disabled) {
                        background: #000c3d;
                        color: #fff;
                        transform: scale(1.1);
                        box-shadow: 0 4px 12px rgba(0, 12, 61, 0.3);
                    }
                    
                    .quantity-btn:disabled {
                        border-color: #ccc;
                        color: #ccc;
                        cursor: not-allowed;
                        opacity: 0.5;
                    }
                    
                    .quantity-input {
                        width: 60px;
                        height: 32px;
                        border: 2px solid #000c3d;
                        border-radius: 16px;
                        text-align: center;
                        font-weight: bold;
                        font-size: 14px;
                        color: #000c3d;
                        background: #fff;
                        transition: all 0.3s ease;
                    }
                    
                    .quantity-input:focus {
                        outline: none;
                        border-color: #1a4b8c;
                        box-shadow: 0 0 0 0.2rem rgba(0, 12, 61, 0.25);
                        transform: scale(1.05);
                    }
                    
                    .quantity-input::-webkit-inner-spin-button,
                    .quantity-input::-webkit-outer-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }
                    
                    .quantity-input[type=number] {
                        -moz-appearance: textfield;
                    }
                    
                    /* Dark mode adjustments */
                    [data-theme="dark"] .quantity-btn {
                        background: #2a2a2a;
                        border-color: #000c3d;
                        color: #000c3d;
                    }
                    
                    [data-theme="dark"] .quantity-btn:hover:not(:disabled) {
                        background: #000c3d;
                        color: #fff;
                    }
                    
                    [data-theme="dark"] .quantity-input {
                        background: #2a2a2a;
                        border-color: #000c3d;
                        color: #fff;
                    }
                    
                    [data-theme="dark"] .quantity-input:focus {
                        border-color: #1a4b8c;
                        background: #1a1a1a;
                    }
                    
                    /* تحسينات إضافية للتصميم */
                    .hover-shadow:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 8px 25px rgba(0,0,0,0.15);
                        transition: all 0.3s ease;
                    }
                    
                    .card {
                        transition: all 0.3s ease;
                    }
                    
                    .card:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 8px 25px rgba(0,0,0,0.1);
                    }
                    
                    .form-check:hover {
                        background-color: #f8f9fa;
                        border-color: #007bff;
                    }
                    
                    .btn-success:hover:not(:disabled) {
                        transform: translateY(-2px);
                        box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
                    }
                    
                    /* تحسينات الـ Radio Button */
                    .form-check-input:checked {
                        background-color: #007bff;
                        border-color: #007bff;
                    }
                    
                    .form-check-input:focus {
                        border-color: #007bff;
                        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
                    }
                    
                    .transition-all {
                        transition: all 0.3s ease;
                    }
                    
                    .bg-primary-subtle {
                        background-color: rgba(0, 123, 255, 0.1) !important;
                    }
                    
                    .form-check:hover {
                        background-color: #f8f9fa;
                        border-color: #007bff !important;
                        transform: translateY(-1px);
                    }
                    
                    .form-check:hover .rounded-circle {
                        border-color: #007bff !important;
                    }
                `}
            </style>
        </>
    );
}

export default Checkout;
